import React from "react";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "./ViewJsonSplitButton.scss";

interface ViewJsonSplitButtonProps {
  /** Called when the "View JSON" label side of the button is clicked. */
  onViewJson: () => void;
  /** Called when the copy icon side of the button is clicked. */
  onCopyJson: () => void;
  /**
   * Optional extra CSS class names appended to the button element.
   * Use this for one-off overrides such as "min-width-auto".
   */
  className?: string;
}

/**
 * A split-button that combines a "View JSON" action (left side) with a
 * copy-to-clipboard action (right side, separated by a vertical divider).
 *
 * Renders a split button for viewing and copying the JSON payload.
 */
const ViewJsonSplitButton: React.FC<ViewJsonSplitButtonProps> = ({
  onViewJson,
  onCopyJson,
  className,
}) => {
  const buttonClass = [
    "btn-orange",
    "btn-dark",
    "vjsb-button",
    ...(className ? [className] : []),
  ].join(" ");

  return (
    <Button
      type="button"
      className={buttonClass}
      color="secondary"
      variant="contained"
      onClick={onViewJson}
    >
      <span className="vjsb-label">View JSON</span>
      <span className="vjsb-divider" aria-hidden="true" />
      <span
        className="vjsb-copy-icon"
        onClick={(e) => {
          e.stopPropagation();
          onCopyJson();
        }}
        title="Copy JSON to clipboard"
        role="button"
        aria-label="Copy JSON to clipboard"
      >
        <ContentCopyIcon sx={{ fontSize: "18px" }} />
      </span>
    </Button>
  );
};

export default ViewJsonSplitButton;
